import React from 'react';
import type { TooltipProps } from '@material-ui/core';
import { Tooltip, makeStyles } from '@material-ui/core';

export interface StyledTooltipProps extends Omit<TooltipProps, 'classes'> {
    backgroundColor?: string;
}

interface StyleProps {
    backgroundColor?: string;
}

const useStyles = makeStyles({
    tooltip: (props: StyleProps) => ({
        fontSize: '12px',
        maxWidth: 200,
        fontWeight: 400,
        backgroundColor: props.backgroundColor
    }),
    arrow: (props: StyleProps) => ({
        color: props.backgroundColor
    })
});

// We intensionally used components from @material-ui/core becasue Interstate's Tooltip does not support html content in the tooltip which is required for BalloonTermTypeField's tooltip content.
export const StyledTooltip: React.FC<StyledTooltipProps> = ({ backgroundColor, children, ...props }) => {
    const classes = useStyles({ backgroundColor });
    return React.createElement(Tooltip, { ...props, classes, children });
};
